<template>
  <div class="title search-editorpick-title">
    <template v-if="isSearchView">
      <h2 @click.prevent="goMoveTab" class="title-area">
        <span class="label">{{sectionInfo.title}}</span>
        <span class="count">{{sectionInfo.count}}</span>
      </h2>
      <a href="#" class="btn-more" @click.prevent="viewAll(sectionInfo)">
        <span>더보기</span>
        <i>더보기 아이콘</i>
      </a>
    </template>
    <template v-else>
      <h2>{{sectionInfo.title}}</h2>
    </template>
  </div>
</template>

<script>
import MultiSectionMixin from '@/mixins/multisection.mixin'
import { bandTitle } from '@/common/resources/directives'
// import { EventBus } from '@/components/eventbus/EventBus'
// import { getTypeCodeFromTitleString } from '@/common/util/common'
// import NextButtonBlack from '@/assets/svg/common/ic-next-s-b.svg'

export default {
  name: 'TitleOnly',
  props: { sectionInfo: { type: Object } },
  data () {
    return {
      isSearchView: true
    }
  },
  mixins: [
    MultiSectionMixin
  ],
  components: {
  },
  directives: {
    bandTitle
  },
  methods: {
    goMoveTab () {
      // EventBus.$emit('tab-type', getTypeCodeFromTitleString(this.sectionInfo.title))
    }
  },
  created () {
    this.isSearchView = this.$route.name === 'search'
  }
}
</script>
